import React, {Component} from 'react';
import {connect} from "react-redux";

class MiniSelectbox extends Component {

    render() {
        return (
            <div className="mini-select-box">
                {
                    this.props.items.map((item, i) =>
                        <button key={'b' + i} onClick={() => this.props.onChange(item)}
                                className={this.props.value && this.props.value[this.props.keyItem] === item[this.props.keyItem] ? "active" : ""}>
                            <span>
                                {item[this.props.keyItem]}
                            </span>
                            {this.props.value && this.props.value[this.props.keyItem] === item[this.props.keyItem] && <i className="icon-checkmark-outline"/>}
                        </button>)
                }
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniSelectbox)
